import axios from 'axios';
// import router from '../router';
// import store from '../store';
import fecha from 'fecha';

const api =  function(){

    //var hasAuthenticated = false;

    var apiURL = process.env.VUE_APP_API?process.env.VUE_APP_API:"";
    console.log("Node url", process.env);

    let endpoints = {
        obtainJWT: apiURL+'/api/token/',
        refreshJWT: apiURL+'/api/token/refresh/',
        baseURL: apiURL+'/api/'
    }

    function isValidDate(date){
        if (Object.prototype.toString.call(date) === "[object Date]") {
            // it is a date
            if (isNaN(date.getTime())) {  // d.valueOf() could also work
              // date is not valid
            } else {
              // date is valid
              return true;
            }
          } else {
            // not a date
          }

          return false;
    }

    function timestamp(date){
        if(isValidDate(date)){
            return fecha.format(new Date(), 'YYYY-MM-DDTHH:mm');
        }
    }

    function isResponseAuthorized(response) {

        console.log("isResponseAuthorized?",response.status);
        if(response.status == 401 || response.status == 403){
            console.log(response.status, response.statusText);
            return false;
        }

        return true;
    }

    async function checkAuthenticationStatus(){
        var success = false;
        console.log("checkAuthenticationStatus");
        await apiRequest("get","").then((response) => {
            
            if(response.success && response.success.status == 200){
                console.log("checkForAuthentication passed");
                success = true;
            }else{
                console.log("checkForAuthenticationStatus failed", response);
            }
        })
        .catch((error) => {
            console.log("checkForAuthenticationStatus failed", error);
        })

        return success;
    }

    function handleResponseErrors(error){

        console.log("handling error");
        //removeToken();
            
            if(error.response){
                console.log("response");
                console.log(error.response);
            }else if(error.request){
                console.log("request");
                console.log(error.request);
            }else{
                console.log("error", error.message)
            }
            
            
            console.log(error.config)
    }

    // function hasValidCredentials(){
    //     return apiRequest("get","").then((response)=>{
    //         if(response.status == 200){
    //             //alert("is authorized")
    //         }else{
    //             alert(response.statusText);
    //         }
    //
    //     })
    // }

    function authenticate(username, password){

        console.log("authenticate");

        const payload = {
            username: username,
            password: password
        }



        return axios.post(endpoints.obtainJWT, payload)
        .then((response) => {
            console.log(response);

            if(isResponseAuthorized(response)){
                if(response.status == 200){
                
                    if(response.data){
                        updateToken(response.data, username);
                        return true;
                    }else{
                        removeToken();
                        return false;
                    }
                }
            }else{
                removeToken();
                return false;
            }

            
        })
        .catch((error) => {

            handleResponseErrors(error);
            
            return false;
        })
    }


    function getAccessToken(){
        return window.localStorage.getItem('accessToken');
    }

    function getRefeshToken(){
        return window.localStorage.getItem('refreshToken');
    }

    async function apiRequest(method, resource, data, params){

        var successfulResponse;
        var errorResponse;
        var shouldTryRefresh = false;
        var redirect;

        if(getAccessToken() || getRefeshToken()){
            
        

            let headers  = {
                    'Authorization': 'Bearer ' + getAccessToken()
            }
            
            var config = {
                url: endpoints.baseURL + resource,
                method: method,
                headers: headers,
            }

            

            if(data){
                config.data = data;
            }

            if(params){
                config.params = params;
            }

            console.log("sending api request", config);

            


            await axios.request(config).then((response)=>{

                
                if(isResponseAuthorized(response)){
                    console.log("response successful first time", response);
                    successfulResponse = response;
                }else{
                    console.log("first response was not authorized, should try refresh");
                    shouldTryRefresh = true;
                }

            })
            .catch((error)=>{

                console.log("Caught error in api request", error.response);
                errorResponse = error;
                if(error.response && (error.response.status == 401) && getRefeshToken()){
                    shouldTryRefresh = true;
                }

            })

            if(shouldTryRefresh){
                console.log("Refresh token and retry")
                var refreshSuccessful;
                await refreshAccessToken().then((refreshed)=>{
                    refreshSuccessful = refreshed;
                })

                if(refreshSuccessful){
                    console.log("token refreshed, will try api request again");

                    config.headers.Authorization = 'Bearer ' + getAccessToken();

                    await axios.request(config).then((response)=>{

                        
                        if(isResponseAuthorized(response)){
                            console.log("response successful second time");
                            successfulResponse = response;
                            errorResponse = undefined;
                        }else{
                            console.log("second try did not authorize");
                            errorResponse = response;
                        }
                    })
                    .catch((error)=>{
                        console.log("Second try failed in error", error);
                        errorResponse = error;
                    })
                }
            }
    }else{
        console.log("No access token");
            errorResponse = new Error("No access token present");
            redirect = { name: "login"}
    }

        return {
            success: successfulResponse,
            error: errorResponse,
            redirect: redirect
        }
    }

    async function refreshAccessToken(){
        console.log("refreshing token");
        var refreshed;
        if(getRefeshToken()){
            console.log("refreshing access token");
            await axios.post(endpoints.refreshJWT, { refresh: getRefeshToken()}).then((response) => {
                if(response.data && response.data.access){

                    console.log("refesh succcesful", response.data.access);
                    updateToken({
                        access: response.data.access,
                        refresh: getRefeshToken()
                    })

                    refreshed = response.data.access;
                }else{
                    removeToken();
                    return null;
                }
            })
            .catch((err) => {
                console.log("token refresh failed",err);
                removeToken();
            })
        }else{
            console.log("No refresh token available");
        }

        return refreshed;
        
    }

    function updateToken(token, username){
        console.log("updating tokens");
        window.localStorage.setItem('accessToken', token.access);
        window.localStorage.setItem('refreshToken', token.refresh);

        if(username){
            window.localStorage.setItem('apiUser', username);
        }
    }

    function getUsername(){
       return window.localStorage.getItem('apiUser');
    }

    function removeToken(){
        console.log("removing tokens");
        window.localStorage.removeItem('accessToken');
        window.localStorage.removeItem('refreshToken');
    }

    function clearAccessToken(){
        console.log("clearing access token");
        window.localStorage.removeItem('accessToken');
    }

    async function getRecord(resource, params){

        var result;
        var error;
        var redirect;

        await apiRequest("get", resource, null, params).then((response) => {
            if(response.success){
                result = response.success.data;
            }else{
                console.log("Failed at api level", response.error);
                error = response.error;
                redirect = response.redirect;
                //alert("Request Failed");
            }
        })
        .catch((err) => {
            console.log("Failed at server level", err);
            err = error;
            //alert("Network Error");
        })

        return {
            result: result,
            error: error,
            redirect: redirect
        }
    }

    async function getRecords(resource, params){

        var results;
        var error;
        var redirect;

        await apiRequest("get", resource, null, params).then((response) => {

            console.log("get", response);

            if(response.success){

                results = response.success.data.results;
            }else{
                console.log("Failed at api level", response.error);
                error = response.error;
                redirect = response.redirect;
                //alert("Request Failed");
            }
        })
        .catch((err) => {
            console.log("Failed at server level", err);
            err = error;
            //alert("Network Error");
        })

        return {
            results: results,
            error: error,
            redirect: redirect
        }
    }


    return {
        getAccessToken,
        apiRequest,
        clearAccessToken,
        removeToken,
        authenticate,
        checkAuthenticationStatus,
        getRecords,
        getRecord,
        timestamp,
        isValidDate,
        getUsername
    }



}

const API = {
    install: function(Vue){
        console.log("installing API");
        Vue.prototype.$http = axios;
        Vue.prototype.$api = api();

        Date.prototype.addDays = function(days) {
            var date = new Date(this.valueOf());
            date.setDate(date.getDate() + days);
            return date;
        }

        Date.prototype.yyyymmdd = function(slash) {

            var mm = this.getMonth() + 1; // getMonth() is zero-based
            var dd = this.getUTCDate();

            let separator = slash?"/":"-";



            return [this.getFullYear(),
                (mm>9 ? '' : '0') + mm,
                (dd>9 ? '' : '0') + dd
            ].join(separator);
        };

        Date.prototype.mmddyyyy = function() {

            var mm = this.getMonth() + 1; // getMonth() is zero-based
            var dd = this.getUTCDate();

            let separator = "/";



            return [
                (mm>9 ? '' : '0') + mm,
                (dd>9 ? '' : '0') + dd,
                this.getFullYear()
            ].join(separator);
        };

        Date.prototype.HHmm = function() {

            return this.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false  })
        };

        Date.prototype.xlsDate = function(inDate) {
            let returnDateTime = 25569.0 + ((inDate.getTime() - (inDate.getTimezoneOffset() * 60 * 1000)) / (1000 * 60 * 60 * 24));
            return returnDateTime.toString().substr(0,20);
        }


        Vue.filter('datetime', function(value) {
            //console.log("formatting date", value);
            if(!value) return ''
            let date = new Date(value);
            if(date){
                return fecha.format(date, "MM/DD/YYYY hh:mm a");
            }else{
                return ''
            }
            
          })

          Vue.filter('date', function(value) {
            //console.log("formatting date", value);
            if(!value) return ''
            let date = new Date(value);
            //console.log(date);
            if(date){
                return fecha.format(date, "MM/DD/YYYY");
            }else{
                return ''
            }
            
          })

          Vue.filter('time', function(value) {
            //console.log("formatting date", value);
            if(!value) return ''
            let date = new Date(value);
            if(date){
                return fecha.format(date, "h:mm a");
            }else{
                return ''
            }
            
          })

          Vue.filter('timespan', function(minutes) {
            //console.log("formatting timespan", minutes);
            //

            let value = parseInt(minutes);
            if(!value || isNaN(value)){
                return "0m"
            }
            
            let min = value % 60;
            let hours = parseInt(value / 60);

            if(hours){
                if(min < 10){
                    return `${hours}h 0${min}m`
                }

                return `${hours}h ${min}m`;
            }else{
                return `${min}m`
            }

            
            
          })

          Vue.filter('dashedblank', function(value) {
            //console.log("formatting date", value);
            if(typeof value != "number"){
                if(!value) return '---'
            }
            
            return value;
            
          })

          Vue.filter('capitalize', function(value) {
            
            if(!value) return ''

            value = value.toString();
            return value.charAt(0).toUpperCase() + value.slice(1);
            
            
          })

          Vue.filter('percent', function(value, decimals = 0) {
            
            if(isNaN(parseFloat(value))) return '0'

            value = value * 100;
            if(!decimals){
                value = Math.round(value);
            }else{
                let multiplier = Math.pow(10,decimals);
                value = parseInt(value * multiplier) / multiplier;
            }
            return value;
            
            
          })

          Vue.filter('decimal', function(value, digits = 0) {
            
            if(isNaN(parseFloat(value))) return 0
            
            if(!digits){
                value = Math.round(value);
            }else{
                let multiplier = Math.pow(10,digits);
                value = parseInt(value * multiplier) / multiplier;
            }
            return value;
            
            
          })


    }
}

export default API;